import { XMarkIcon } from "@heroicons/react/24/outline";
import * as Dialog from "@radix-ui/react-dialog";
import { FriendRequestStatus } from "@compass/shared/types";

type DeclineModalProps = {
    isOpen: boolean;
    userName?: string;
    userId: number;
    setIsOpen: (isOpen: boolean) => void;
    onDecline: ({ id, status }: { id: number; status: FriendRequestStatus }) => void;
};

export const DeclineModal = ({
    isOpen,
    setIsOpen,
    onDecline,
    userName,
    userId,
}: DeclineModalProps) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-xs -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg shadow-lg">
                    <div className="relative bg-white p-2">
                        <Dialog.Close asChild>
                            <button className="absolute top-2 right-2 rounded-full p-1 text-gray-600 transition-transform duration-150 hover:text-black focus:outline-none focus:ring-0">
                                <XMarkIcon className="h-4 w-4" />
                            </button>
                        </Dialog.Close>
                    </div>

                    {/* content */}
                    <div className="space-y-4 bg-white p-4">
                        <p className="text-large font-semibold text-gray-800">
                            Are you sure you want to decline {userName}?
                        </p>

                        <div className="flex justify-start gap-2">
                            <button
                                className="rounded bg-[#2C9AFF] px-4 py-1.5 text-sm font-medium text-white hover:bg-[#1f7cd6]"
                                onClick={() => {
                                    onDecline({
                                        id: userId,
                                        status: "DECLINED",
                                    });
                                    setIsOpen(false);
                                }}
                            >
                                Decline
                            </button>
                            <Dialog.Close asChild>
                                <button className="rounded bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-200">
                                    Cancel
                                </button>
                            </Dialog.Close>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
